/**
 * Hosting onboarding process.
 *
 * This would be something nice to redo in React...
 *
 * @param {object} window
 * @param undefined
 */
(function( window, undefined ){

	window.wp = window.wp || {};
	var document = window.document;
	var $ = window.jQuery;
	var wp = window.wp;

	/**
	 * @since 1.1.0
	 * @type {object}
	 */
	var self = Astoundify.HostingOnboarding = _.extend( {}, {
		$industrySelector: $( '#industry-selector' )
	}, Astoundify.HostingOnboarding || {} );

	/**
	 * Bind to the DOM
	 *
	 * @since 1.1.0
	 */
	$(document).ready(function() {

		/**
		 * Load baesd on set hash.
		 *
		 * @since 1.1.0
		 */
		if ( window.location.hash ) {
			var theme = window.location.hash.replace( '#', '' );

			$( '.js-choose-theme' ).attr( 'href', $( '.js-choose-theme' ).attr( 'href' ).replace( 'step=2', 'step=3' ) );

			$( '.type-download' ).hide();
			$( '[data-theme="' + theme + '"]' ).css( 'animation', 'none' ).show().animate({
				opacity: 1
			});
		}

		/**
		 * Filter previews by industry.
		 *
		 * @since 1.1.0
		 */
		self.$industrySelector.on( 'change', function() {
			var industry = $(this).val();

			if ( '' == industry ) {
				$( '.type-download' ).show();

				return;
			}

			$( '.type-download' ).hide();
			$( '[data-industry="' + industry + '"]' ).css( 'animation', 'none' ).show().animate({
				opacity: 1
			});
		});

	});

})( window );
